module.exports = __webpack_public_path__ + "7545e0680147e495aae647f8d97a6555.jpg";